/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TariffPriceWorkingPrices { 
    /**
     * name of working price component
     */
    name?: string;
    /**
     * value of working price component
     */
    value?: number;
}

